<template>
    <aside class="aside aside-fixed">
        <div class="aside-header">
            <a href="#" class="aside-logo">
              <img src="https://rubies-ibank-test-two.s3-us-west-2.amazonaws.com/img/new-rubies/logo.png" height="40px" width="100px"/>
            </a>
            <a href="" class="aside-menu-link">
                <i data-feather="menu"></i>
                <i data-feather="x"></i>
            </a>
            <a href="" id="chatContentClose" class="burger-menu d-none"><i data-feather="arrow-left"></i></a>
            <a href="" id="contactContentHide" class="burger-menu d-none"><i data-feather="arrow-left"></i></a>
        </div>
        <div class="aside-body">
            <div class="aside-loggedin">
                <div class="d-flex align-items-center justify-content-start">
<!--                    <a href="#" class="avatar"><img src="https://via.placeholder.com/500" class="rounded-circle" alt=""></a>-->
<!--                    <div class="aside-alert-link">-->
<!--                        <router-link to="#" class="new" data-toggle="tooltip" title="You have 2 unread messages"><i data-feather="message-square"></i></router-link>-->
<!--                        <router-link to="#" class="new" data-toggle="tooltip" title="You have 4 new notifications"><i data-feather="bell"></i></router-link>-->
<!--                        <a href="/" data-toggle="tooltip" title="Sign out"><i data-feather="log-out"></i></a>-->
<!--                    </div>-->
                </div>
                <div class="aside-loggedin-user">
                    <a href="#loggedinMenu" class="d-flex align-items-center justify-content-between mg-b-2" data-toggle="collapse">
                        <bar-loader v-if="company.company[0] == null" class="custom-class" color="#6d0606" loading="loading" :size="150" sizeUnit="px"></bar-loader>
                        <h6 class="tx-semibold mg-b-0">{{company.company[0] == null? '':$store.getters['company/accountName']}}</h6>
                        <i data-feather="chevron-down"></i>
                    </a>
                    <p class="tx-color-03 tx-12 mg-b-0">Administrator</p>
                </div>
                <div class="collapse" id="loggedinMenu">
<!--                    <div class="position-relative form-group">-->
<!--                        </div>-->
                    <p v-if="companies.length > 0" class="mt-1 mb-0">Switch Company</p>
                    <multiselect
                            v-if="companies.length > 0"
                            label="orgName"
                            track-by="orgName"
                            style="font-size: 12px;"
                            class="mt-0" v-model="activeCompany"
                            :options="companies"
                            :searchable="true"
                            :close-on-select="false"
                            :show-labels="false"
                            placeholder="Switch Company"></multiselect>
                    <ul class="nav nav-aside mg-b-0">
                        <li class="nav-item"><router-link to="/new-company" class="nav-link"><i data-feather="plus-square"></i> <span>Add a Company</span></router-link></li>
                        <li class="nav-item"><router-link to="/personal-profile" class="nav-link"><i data-feather="edit"></i> <span>Personal Profile</span></router-link></li>
                        <li class="nav-item"><router-link to="/officer-profile" class="nav-link"><i data-feather="user"></i> <span>Officer Profile</span></router-link></li>
                        <li class="nav-item"><router-link to="#" class="nav-link"><i data-feather="help-circle"></i> <span>Help Center</span></router-link></li>
                        <li class="nav-item"><a href="#" @click="logout()" class="nav-link"><i data-feather="log-out"></i> <span>Sign Out</span></a></li>
                    </ul>
                </div>
            </div><!-- aside-loggedin -->
            <base-sidebar :menus="menuData"></base-sidebar>
        </div>
    </aside>
</template>

<script>
    import BaseSidebar from "../../views/template/layouts/component/baseComponent/BaseSidebar";
    import {mapState} from "vuex";
    export default {
        components:{
            BaseSidebar
        },
        name: "SideBar",
        data(){
            return{
                model:{
                    activeCompany:{}
                },
                menuData: [
                    {
                        header: true,
                        classType: 'nav-label mt-3',
                        show:true,
                        title: 'Dashboard'
                    },
                    {
                        icon: 'shopping-bag',
                        classType: 'nav-item',
                        title: 'Dashboard',
                        href: '/dashboard',
                        show:true,
                        id:'v-step-0'
                    },
                    {
                        icon: 'layers',
                        classType: 'nav-item',
                        title: 'Details',
                        href: '/dashboard/details',
                        show:true,
                        id:'v-step-1'
                    },
                    {
                        icon: 'users',
                        classType: 'nav-item',
                        title: 'Officers',
                        href: '/officers',
                        show:true,
                        id:'officer'
                    },
                    {
                        icon: 'file-text',
                        classType: 'nav-item',
                        title: 'Documents',
                        href: '/documents',
                        show:true,
                        id:'document'
                    },
                    {
                        header: true,
                        classType: 'nav-label mt-3',
                        title: 'Corp. Internet Banking',
                        show:true,
                    },
                    {
                        icon: 'user',
                        classType: 'nav-item',
                        title: 'Create User',
                        href: '/create-user',
                        show:true,
                        id:'createuser'
                    },
                    {
                        header: true,
                        classType: 'nav-label mt-3',
                        title: 'Dispute Resolution',
                        show:true,
                    },
                    {
                        icon: 'rss',
                        classType: 'nav-item',
                        title: 'Submit Dispute',
                        href: '/submit-dispute',
                        show:true,
                    },
                    {
                        icon: 'sliders',
                        classType: 'nav-item',
                        title: 'Disputes',
                        href: '/disputes',
                        show:true,
                    },
                    {
                        header: true,
                        classType: 'nav-label mt-3',
                        title: 'Developer Console',
                        show:true
                    },
                    {
                        icon: 'activity',
                        new:'yes',
                        classType: 'nav-item',
                        title: 'Dashboards',
                        href: '/developer-dashboard',
                        show:true
                    },
                    {
                        icon: 'align-justify',
                        classType: 'nav-item',
                        title: 'Transactions',
                        href: '/transactions',
                        show:true
                    },
                    {
                        icon: 'terminal',
                        classType: 'nav-item',
                        title: 'Name Enquiries',
                        href: '/name-enquiries',
                        show: true
                    },
                    {
                        icon: 'settings',
                        classType: 'nav-item',
                        title: 'Settings',
                        new:'yes',
                        href: '/settings',
                        show: true
                    },
                    {
                        icon: 'briefcase',
                        classType: 'nav-item',
                        title: 'Virtual Accounts',
                        new:'yes',
                        href: '/virtual-accounts',
                        show: true
                    },
                    {
                        icon: 'align-justify',
                        classType: 'nav-item',
                        title: 'V.Acc Transactions',
                        new:'yes',
                        href: '/virtual-transaction',
                        show:true

                    },
                    {
                        icon: 'align-justify',
                        classType: 'nav-item',
                        title: 'Wallets',
                        new:'yes',
                        href: '/read-wallets',
                        show: true
                    },
                    {
                        icon: 'bookmark',
                        classType: 'nav-item',
                        title: 'Api Documentation',
                        href: '/api-documentation',
                        show: true
                    }

                ]

            }
        },
        methods:{
            officerFilteredByUserId(_item) {
                return this.officer.officers.filter(function (el) {
                    return el.officerUserID == _item;
                });
            },
            async initDashboard(){
                localStorage.removeItem("accNumber");
                localStorage.removeItem("accID");
                this.$store.commit("company/updateAcc",'');
                //console.log('>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>calling')
                this.$store.commit('system/updateAppLoading', true);
                await this.$store.dispatch("system/updateUserInfo", {payload:"you"}, { root: false });
                if(this.system.userInfo != null) await this.$store.dispatch("company/updateCompanies", {
                    userID: this.system.userInfo.id,
                    requestType: 'company'
                }, { root: false });
                else this.$router.push('/');
                if(this.system.userInfo != null) await this.$store.dispatch("system/updateDashboard", {
                    orgID: localStorage.orgID,
                    userID: this.system.userInfo.id,
                    accID: localStorage.accID,
                    requestType: 'dashboard'
                }, {root: true});
                await this.$store.dispatch("officer/updateOfficers", {
                    orgID: localStorage.orgID,
                    accID: localStorage.accID,
                    requestType: 'officer'
                }, {root: true});
                //console.log(this.company.companies);
                console.log(this.company.account[0]);
                this.$store.dispatch("logs/readFtLogs", {
                    customerId: this.company.account[0].accCustID
                }, {root: true});
                this.$store.dispatch("logs/readNeLogs", {
                    customerId: this.company.account[0].accCustID
                }, {root: true});
                this.$store.dispatch("setting/getApiKey", {
                    apiKeyAccountNumber: this.company.account[0].accNumber,
                    env: 'prod'
                }, {root: true});
                if (this.company.companies.length > 0) this.$store.dispatch("wallets/getWallets", {
                    groupCode: this.setting.apiKeys.apikeyCustomerID
                    // customerId: this.company.accounts[0].accCustID
                }, {root: true})
                if (this.company.companies.length > 0) await this.$store.dispatch("wallets/readWallets", {
                    customerId: this.setting.apiKeys.apikeyCustomerID
                    // customerId: this.company.accounts[0].accCustID
                }, {root: true})
                if (this.company.companies.length > 0) this.$store.dispatch("logs/balanceEnquiry", {
                    accountnumber: this.company.account[0].accNumber,
                    env: 'prod'
                }, {root: true});
                if (this.officerFilteredByUserId(this.system.userInfo.id)[0] != null)
                    if (
                        this.officerFilteredByUserId(this.system.userInfo.id)[0].officerPassportURL === '' ||
                        this.officerFilteredByUserId(this.system.userInfo.id)[0].officerPassportURL == null ||
                        this.officerFilteredByUserId(this.system.userInfo.id)[0].officerSignatureURL === '' ||
                        this.officerFilteredByUserId(this.system.userInfo.id)[0].officerSignatureURL == null
                    ){
                        const options = {title: 'Warning!', size: 'sm'}
                        this.$dialogs.alert('Please complete your officer profile for this account', options)
                            .then(res => {
                                console.log(res) // {ok: true|false|undefined}
                                this.$router.push('/officer-profile')
                            })
                    }
                this.$store.commit('system/updateAppLoading', false);
            },
            logout(){
                localStorage.clear();
                window.location = '/';
            }
        },
        computed:{
            ...mapState([
                'company',
                'officer',
                'setting',
                'system'
            ]),
            companies:{
                get(){
                    let comps = [];
                    this.company.companies.forEach(
                        company => {
                            if(company.orgID !== localStorage.orgID)
                                comps.push({
                                orgName: company.orgName,
                                orgID: company.orgID
                            })
                        }
                    );
                    return comps;
                },
                set(){
                    console.log('heyyyyyyy')
                    localStorage.orgID = this.model.activeCompany.orgID
                    this.initDashboard()
                }
            },
            activeCompany:{
                get(){
                    return this.model.activeCompany;
                },
                set(val){
                    if (val != null) {
                        this.model.activeCompany = val
                        localStorage.orgID = this.model.activeCompany.orgID
                        this.initDashboard()
                    }
                }
            },
            admin:{
                get(){
                    let access = false;
                    if (this.system.userInfo.role.toUpperCase() === "USER" ||
                        this.system.userInfo.role.toUpperCase() === "DIRECTOR" ||
                        this.system.userInfo.role.toUpperCase() === "SIGNATORY" ||
                        this.system.userInfo.role.toUpperCase() === "DIRECTOR&SIGNATORY" ||
                        this.system.userInfo.role.toUpperCase() === "DIRECTORANDSIGNATORY")
                        access = true;
                    return access;
                }
            },
            customerService:{
                get(){
                    let access = false;
                    if (this.system.userInfo.role.toUpperCase() === "CUSTOMERSERVICE")
                        access = true
                    return access;
                }
            },
            developer:{
                get(){
                    let access = false;
                    if (this.system.userInfo.role.toUpperCase() === "DEVELOPER")
                        access = true
                    return access;
                }
            },
            menuDataNew:{
                get(){
                    let menu = [
                        {
                            header: true,
                            classType: 'nav-label mt-3',
                            show:true,
                            title: 'Dashboard',
                        },
                        {
                            icon: 'shopping-bag',
                            classType: 'nav-item',
                            title: 'Dashboard',
                            href: '/dashboard',
                            show:true,
                        },
                        {
                            icon: 'layers',
                            classType: 'nav-item',
                            title: 'Details',
                            href: '/dashboard/details',
                            show:true,
                        },
                        {
                            icon: 'users',
                            classType: 'nav-item',
                            title: 'Officers',
                            href: '/officers',
                            show:this.admin,
                        },
                        {
                            icon: 'file-text',
                            classType: 'nav-item',
                            title: 'Documents',
                            href: '/documents',
                            show:this.admin,
                        },
                        {
                            header: true,
                            classType: 'nav-label mt-3',
                            title: 'Corp. Internet Banking',
                            show:this.admin,
                        },
                        {
                            icon: 'user',
                            classType: 'nav-item',
                            title: 'Create User',
                            href: '/create-user',
                            show:this.admin,
                        },
                        {
                            header: true,
                            classType: 'nav-label mt-3',
                            title: 'Dispute Resolution',
                            show:true,
                        },
                        {
                            icon: 'rss',
                            classType: 'nav-item',
                            title: 'Submit Dispute',
                            href: '/submit-dispute',
                            show:true,
                        },
                        {
                            icon: 'sliders',
                            classType: 'nav-item',
                            title: 'Disputes',
                            href: '/disputes',
                            show:true,
                        },
                        {
                            header: true,
                            classType: 'nav-label mt-3',
                            title: 'Developer Console',
                            show:true
                        },
                        {
                            icon: 'activity',
                            new:'yes',
                            classType: 'nav-item',
                            title: 'Dashboards',
                            href: '/developer-dashboard',
                            show:true
                        },
                        {
                            icon: 'align-justify',
                            classType: 'nav-item',
                            title: 'Transactions',
                            href: '/transactions',
                            show:true
                        },
                        {
                            icon: 'terminal',
                            classType: 'nav-item',
                            title: 'Name Enquiries',
                            href: '/name-enquiries',
                            show: true
                        },
                        {
                            icon: 'settings',
                            classType: 'nav-item',
                            title: 'Settings',
                            new:'yes',
                            href: '/settings',
                            show: true
                        },
                        {
                            icon: 'briefcase',
                            classType: 'nav-item',
                            title: 'Virtual Accounts',
                            new:'yes',
                            href: '/virtual-accounts',
                            show: true
                        },
                        {
                            icon: 'align-justify',
                            classType: 'nav-item',
                            title: 'V.Acc Transactions',
                            new:'yes',
                            href: '/virtual-transaction',
                            show:true

                        },
                        {
                            icon: 'align-justify',
                            classType: 'nav-item',
                            title: 'Wallets',
                            new:'yes',
                            href: '/read-wallets',
                            show: true
                        },
                        {
                            icon: 'bookmark',
                            classType: 'nav-item',
                            title: 'Api Documentation',
                            href: '/api-documentation',
                            show: true
                        }

                    ];
                    return menu
                },
                set(val){
                    console.log(val)
                }
            }
        },
        mounted() {
            // this.$tours['myTour'].start()
        }
    }
</script>

<style scoped>

</style>